var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"truncate flex flex-col gap-2"},_vm._l((_vm.fields),function(field){return _c('span',{key:field.name,staticClass:"truncate",class:{'font-semibold': field.highlight}},[_vm._v("\n    "+_vm._s(field.value)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }